import { AddressHelper } from '@/helpers/addressHelper';
import { PropertyHelper } from '@/helpers/property.helper';
import { CurrencyPipe, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { Attribute } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { RealPropertyMutable } from '../property-add-full-dialog/property-add-full-dialog.component';

@Component({
  selector: 'app-property-add-certify',
  templateUrl: './property-add-certify.component.html',
  styleUrls: ['./property-add-certify.component.scss'],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgIf, MatRadioModule, MatFormFieldModule, CurrencyPipe]
})
export class PropertyAddCertifyComponent {
  @Input() prop: RealPropertyMutable;
  @Output() propertyUpdated = new EventEmitter<RealPropertyMutable>();

  sub = new Subscription();
  subProp = new Subscription();
  formSubmitting = false;

  propertyName: string;
  propertyAddress: string;
  propertyLandRegistry: string;
  propertyOtherLandRegistries: string[] = [];
  propertyOtherLandRegistriesDisplay: string;
  propertyCondo: string;
  propertyOnSale: boolean;
  propertySalePrice: number;
  propertySaleDate: string;

  requiredAttrs: Attribute[];
  get form_certify() {
    return this.form.get('certify') as FormControl<boolean>;
  }
  get form_validateCreate() {
    return this.form.get('validateCreate') as FormControl<boolean>;
  }

  form = this.fb.group({
    certify: [true, Validators.required],
    validateCreate: [true, Validators.required]
  });

  constructor(private fb: UntypedFormBuilder, private propHelper: PropertyHelper) {}

  ngOnInit(): void {
    this.loadData();
    this.sub = this.form_validateCreate.valueChanges.subscribe((v) => {
      this.prop.deleted = !v;
      this.propertyUpdated.emit(this.prop);
    });
  }

  loadData() {
    this.propertyName = this.prop.name;
    this.propertyAddress = AddressHelper.getFullAddress(this.prop.address);
    this.propertyLandRegistry = this.propHelper.getLandRegistryDisplayName(this.prop.landRegistry);
    this.propertyOtherLandRegistries = [];
    this.prop.otherLandRegistries?.forEach((r) =>
      this.propertyOtherLandRegistries.push(this.propHelper.getLandRegistryDisplayName(r))
    );
    this.propertyOtherLandRegistriesDisplay = this.propertyOtherLandRegistries.join(' - ');
    this.propertyCondo = this.prop.details?.isInCondo ? 'Oui' : 'Non';
    this.propertyOnSale = this.prop.onGoingSelling != null;
    this.propertySalePrice = this.prop.onGoingSelling?.price;
    this.propertySaleDate = this.prop.onGoingSelling?.dateOnSale;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.subProp.unsubscribe();
  }

  onSubmit() {
    if (this.form.valid) {
      this.formSubmitting = true;
      this.prop.certified = this.form_certify.value;
      this.prop.deleted = !this.form_validateCreate.value;
      this.propertyUpdated.emit(this.prop);
      this.formSubmitting = false;
    }
  }
}
